
import Home from './components/frontend/Home';
import About from './components/frontend/About';
import Contact from './components/frontend/ContactWrapper';
import Events from './components/frontend/EventsWrapper';
import Help from './components/frontend/Help';

import Radios from './components/frontend/Radios';
import Podcasts from './components/frontend/Podcasts';

import Login from './components/frontend/auth/Login';
import Register from './components/frontend/auth/Register';
import ActivateAccount from './components/frontend/auth/ActivateAccount';
import ForgotPassword from './components/frontend/auth/ForgotPassword';
import ResetPassword from './components/frontend/auth/ResetPassword';

import Album from './components/frontend/Album';

import MemberHome from './components/member/Home';
import MemberSearch from './components/member/Search';
import MemberDonate from './components/member/Donate';
import MemberCreate from './components/member/Create';
import MemberAccount from './components/member/Account';
import MemberProfile from './components/member/Profile';
import MemberSettings from './components/member/Settings';
import MemberAlbum from './components/member/Album';
import MemberPayments from './components/member/Payments';
import MemberPaymentManager from './components/member/PaymentManager';

import AdminDashboard from './components/admin/Dashboard';
import AdminAccount from './components/admin/Account';
import AdminProfile from './components/admin/Profile';
import AdminSettings from './components/admin/Settings';
import AdminPlans from './components/admin/Plans';
import AdminUsers from './components/admin/Users';
import AdminSubscriptions from './components/admin/Subscriptions';

// Radios

const ActivateAccountWithId = ({ id }) => <ActivateAccount id={id} />;
const ResetPasswordWithIdEmail =  ({ id, email }) => <ResetPassword id={id} email={email} />;
const AlbumWithRandomIdType =  ({ random_id, type }) => <Album random_id={random_id} type={type} />;
const MemberAlbumWithRandomIdType =  ({ random_id, type }) => <MemberAlbum random_id={random_id} type={type} />;

const PodcastsWithId = ({ id }) => <Podcasts id={id} />;

const routes = [
	{
		path: '/',
		element: <Home />,
		type: 'public',
	}, {
		path: '/home',
		element: <Home />,
		type: 'public',
	}, {
		path: '/about',
		element: <About />,
		type: 'public',
	}, {
		path: '/contact',
		element: <Contact />,
		type: 'public',
	}, {
		path: '/events',
		element: <Events />,
		type: 'public',
	}, {
		path: '/help',
		element: <Help />,
		type: 'public',
	}, {
		path: '/radios',
		element: <Radios />,
		type: 'public',
	}, {
		path: '/podcasts',
		element: <Podcasts />,
		type: 'public',
	}, {
		path: '/podcasts/:id',
		element: <PodcastsWithId />,
		type: 'public',
	}, {
		path: '/login',
		element: <Login />,
		type: 'public',
	}, {
		path: '/register',
		element: <Register />,
		type: 'public',
	}, {
		path: '/activate_account/:id',
		element: <ActivateAccountWithId />,
		type: 'public',
	}, {
		path: '/forgot_password',
		element: <ForgotPassword />,
		type: 'public',
	}, {
		path: '/reset_password/:id/:email',
		element: <ResetPasswordWithIdEmail />,
		type: 'public',
	}, {
		path: '/member/home',
		element: <MemberHome />,
		type: 'private member',
	}, {
		path: '/member/search',
		element: <MemberSearch />,
		type: 'private member',
	}, {
		path: '/member/donate',
		element: <MemberDonate />,
		type: 'private member',
	}, {
		path: '/member/create',
		element: <MemberCreate />,
		type: 'private member',
	}, {
		path: '/member/account',
		element: <MemberAccount />,
		type: 'private member',
	}, {
		path: '/member/profile',
		element: <MemberProfile />,
		type: 'private member',
	}, {
		path: '/member/settings',
		element: <MemberSettings />,
		type: 'private member',
	}, {
		path: '/member/album/:random_id/:type',
		element: <MemberAlbumWithRandomIdType />,
		type: 'private member',
	}, {
		path: '/member/payments',
		element: <MemberPayments />,
		type: 'private member',
	}, {
		path: '/member/payment_manager',
		element: <MemberPaymentManager />,
		type: 'private member',
	}, {
		path: '/admin/dashboard',
		element: <AdminDashboard />,
		type: 'private admin',
	}, {
		path: '/admin/account',
		element: <AdminAccount />,
		type: 'private admin',
	}, {
		path: '/admin/profile',
		element: <AdminProfile />,
		type: 'private admin',
	}, {
		path: '/admin/settings',
		element: <AdminSettings />,
		type: 'private admin',
	}, {
		path: '/admin/plans',
		element: <AdminPlans />,
		type: 'private admin',
	}, {
		path: '/admin/users',
		element: <AdminUsers />,
		type: 'private admin',
	}, {
		path: '/admin/subscriptions',
		element: <AdminSubscriptions />,
		type: 'private admin',
	},
	// And so on.

	//Radios
];

export default routes;